

/*
CUSTOM SideNavApp
*/

import React, {Component} from "react";
import SideNav, {NavIcon, NavItem, NavText} from "@trendmicro/react-sidenav";
import SUBMIT_EXPERIMENT from "../../gpap-lib/img/icons/clean-hands.svg";
import SUBMIT_FILES from "../../gpap-lib/img/icons/publish.svg";
import HOME from "../../gpap-lib/img/icons/HOME.svg";
import FOLDER from "../../gpap-lib/img/icons/folder.svg";
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import IconButton from '@mui/material/IconButton';
import "./sidenav_custom.css";
import Sideback from "./sideback.svg";

const config = window.config;

class SideNavApp extends Component{

    constructor(props){
        super(props);
        this.state = {
            expanded:false
        };


        this.wrapperRef = React.createRef();

        this.setExpanded = this.setExpanded.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && event.srcElement.className!== undefined && typeof event.srcElement.className === "string" && !event.srcElement.className.includes("sidenav")) {
            this.setState({expanded:false})
        }
    }

    setExpanded(bool){
        this.setState({expanded:bool})
    }


    render(){

        let self = this;

        const STATIC_URL = window.config.static_files;

        let submit_exp_src = STATIC_URL + "/img/data_management/" + "icons/clean-hands.svg";
        let submit_files_src = STATIC_URL + "/img/data_management/" + "icons/publish.svg";
        let home_src = STATIC_URL + "/img/data_management/" + "icons/HOME.svg";
        let folder_src = STATIC_URL + "/img/data_management/" + "icons/folder.svg";
        let sideback_src = STATIC_URL + "/img/data_management/" + "icons/sideback.svg";


        return   <SideNav
            expanded ={this.state.expanded}
            ref={this.wrapperRef}
            onSelect={(selected) => {
                const url_fields = window.location.href.split('#');
                let url_to = url_fields;
                switch (selected) {
                    case "HOME":
                        url_to = `${url_fields[0]}#/`;
                        break;
                    case "SUBMIT_EXPERIMENTS":
                        url_to = `${url_fields[0]}#/selectgroup`;
                        break;
                    case "SUBMIT_FILES":
                        url_to = `${url_fields[0]}#/selectexperiments`;
                        break;
                    case "BROWSE":
                        url_to = `${url_fields[0]}#/management`;
                        break;
                    case "GPAP_HOME":
                        url_to = `${config.domain}`;
                        break;
                }
                if (window.location.href !== url_to) window.location.href = url_to;
            }}
            onToggle={(expanded) => {
                this.setState({ expanded });
            }}
        >
            <SideNav.Toggle/>
            {(this.state.expanded)
                ? <div className="username">
                    <div className="sc-htoDjs dgwEff">{this.props.username}</div>
                    {/*  <div className="sc-dnqmqq fkaFXp">Styled Side Navigation</div>*/}
                </div>
                : null}
            {/**/}
            <SideNav.Nav defaultSelected="HOME">

                <NavItem eventKey="HOME"
                         onMouseOver={() => self.setExpanded(true)}
                         onMouseOut={() => self.setExpanded(false)}>
                    <NavIcon>
                        <img alt="home" src={home_src}/>
                    </NavIcon>
                    <NavText>
                        Home
                    </NavText>
                </NavItem>

                <NavItem eventKey="SUBMIT_EXPERIMENTS"
                         onMouseOver={() => self.setExpanded(true)}
                         onMouseOut={() => self.setExpanded(false)}>
                    <NavIcon>
                        <IconButton aria-label="submit_experiments">
                        <img alt="submitexperiment" src={submit_exp_src}/>
                        </IconButton>
                    </NavIcon>
                    <NavText>
                        Submit Experiment(s)
                    </NavText>
                </NavItem>

                <NavItem eventKey="SUBMIT_FILES"
                         onMouseOver={() => self.setExpanded(true)}
                         onMouseOut={() => self.setExpanded(false)}
                >
                    <NavIcon>
                        <IconButton aria-label="submit_files"
                                    onMouseOver={() => self.setExpanded(true)}
                                    onMouseOut={() => self.setExpanded(false)}>
                        <img alt="submitfiles" src={submit_files_src}/>
                        </IconButton>
                    </NavIcon>
                    <NavText>
                        Submit File(s)
                    </NavText>
                </NavItem>

                <NavItem eventKey="BROWSE"
                         onMouseOver={() => self.setExpanded(true)}
                         onMouseOut={() => self.setExpanded(false)}
                >
                    <NavIcon>
                        <IconButton aria-label="browse_data"
                                    onMouseOver={() => self.setExpanded(true)}
                                    onMouseOut={() => self.setExpanded(false)}>
                        <img alt="folder" src={folder_src}/>
                        </IconButton>
                    </NavIcon>
                    <NavText>
                        Browse Experiments
                    </NavText>
                </NavItem>

                <NavItem eventKey="GPAP_HOME"
                         onMouseOver={() => self.setExpanded(true)}
                         onMouseOut={() => self.setExpanded(false)}
                >
                    <NavIcon>
                        <IconButton aria-label="gpap_home"
                                    onMouseOver={() => self.setExpanded(true)}
                                    onMouseOut={() => self.setExpanded(false)}>
                        <img alt="back" src={sideback_src}/>
                        </IconButton>
                    </NavIcon>
                    <NavText>
                        Go to GPAP Home
                    </NavText>
                </NavItem>

            </SideNav.Nav>
        </SideNav>
    }
}


export default SideNavApp;
